import { render, staticRenderFns } from "./TeamMemberModal.vue?vue&type=template&id=0436aee8&scoped=true&"
import script from "./TeamMemberModal.vue?vue&type=script&lang=js&"
export * from "./TeamMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TeamMemberModal.vue?vue&type=style&index=1&id=0436aee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436aee8",
  null
  
)

export default component.exports